
export const serviceType = [
  {id: "accommodation", name: 'accommodation'},
  {id: "bike_rental", name: 'bike_rental'},
  {id: "transport", name: 'transport'},
  {id: "activity", name: 'activity'}
];
